function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapa caracteres especiales
}

export default function replaceAll(str, find, replace, flags) {
	return str.replace(new RegExp(escapeRegExp(find), flags || 'g'), replace);
}
